import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import { DataGridContainer, FullDivider } from '../../../../../ui/styled';
import {
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../../../../Episode/Episode.Styled';

const InstitutionList = (props) => {
  const { orgInstitutionSapList } = props;

  const [institutionSapData, setInstitutionSapData] = useState({
    isLoading: false,
    data: [],
    total: 0,
    // page: 1,
    // pageSize: 10,
    // sortModel: '',
  });

  useEffect(() => {
    getOrgInstitutionSapList();
  }, [orgInstitutionSapList]);

  const getOrgInstitutionSapList = () => {
    setInstitutionSapData((prveState) => ({ ...prveState, isLoading: true }));
    const json = orgInstitutionSapList;
    setInstitutionSapData((prveState) => ({
      ...prveState,
      isLoading: false,
      data: json?.map((item, index) => ({
        ...item,
        _id: index,
        sapOrgId: item.sapOrgId,
        sapNameOrgKey: item.sapNameOrgKey,
        sapNameOrgSapIntOrgId: item.sapNameOrgSapIntOrgId,
        sapCode: item.sapCode,
        sapNumber: item.sapNumber,
        contactName: item.contactName,
        contactPhone: item.contactPhone,
      })),
    }));
  };

  const columnsData = [
    {
      field: 'sapOrgId',
      headerName: 'SAP Org Id',
      flex: 1,
    },
    { field: 'sapNameOrgKey', headerName: 'SAP Name', flex: 1 },
    {
      field: 'sapCode',
      headerName: 'SAP Code',
      flex: 1,
    },
    { field: 'sapNumber', headerName: 'SAP Number', flex: 1 },
    { field: 'contactName', headerName: 'Contact Name', flex: 1 },
    { field: 'contactPhone', headerName: 'Contact Phone', flex: 1 },
  ];

  const getTitle = () => {
    return (
      <>
        <FullDivider />
        <GridContainer container>
          <Grid item xs={6}>
            <NoteHeading variant='h5'>Sap's for this Institution</NoteHeading>
          </Grid>
          <LeftGrid item xs={6}></LeftGrid>
        </GridContainer>
      </>
    );
  };

  const getDataGrid = () => {
    return (
      <DataGridContainer>
        <DataGrid
          getRowHeight={() => 'auto'}
          columns={columnsData}
          rows={institutionSapData.data}
          // pageSize={contactList.pageSize}
          // page={contactList.page - 1}
          rowCount={institutionSapData.total}
          getRowId={(row) => row._id}
          // paginationMode='server'
          // sortingMode='server'
          // onPageSizeChange={(newPageSize) =>
          //   setContactList((old) => ({ ...old, pageSize: newPageSize }))
          // }
          // onPageChange={(newPage) => {
          //   setContactList((old) => ({ ...old, page: newPage + 1 }));
          // }}
          // rowsPerPageOptions={paginationSize}
          //pagination
          //components={{ Toolbar: QuickSearchToolbar }}
          experimentalFeatures={{ newEditingApi: true }}
          //onSortModelChange={handleSortModelChange}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          loading={institutionSapData.isLoading}
        />
      </DataGridContainer>
    );
  };

  return (
    <>
      {getTitle()}
      {getDataGrid()}
    </>
  );
};

export default InstitutionList;
